import { CreateOrderRequest, PrepaidCardPayments } from '@models/order';
import { PayloadAction, WritableDraft } from '@reduxjs/toolkit';

export function setPrepaidCardPayments(
    state: WritableDraft<CreateOrderRequest>,
    action: PayloadAction<PrepaidCardPayments[]>,
) {
    state.prepaidCardPayments = action.payload;
}
